/* oxlint-disable typescript/no-explicit-any */
import { Reducer } from 'redux';

import { TThunkAction } from '.';
import { updateIsActiveCategory } from './categories';
import { deleteSubscriptionItem, updateIsActive, updateSubscriptionFrequency } from './subscriptions';
import { updateMailingToggle } from '../services';

export type TFailedActionType =
  | 'ISubscriptionsDeleted'
  | 'IIsActiveUpdated'
  | 'IFrequencyUpdated'
  | 'IIsActiveCategoryUpdated'
  | 'IMailingToggleUpdated';

export interface IFailedAction {
  type: TFailedActionType;
  [key: string]: any;
}

export type TFailedActionState = IFailedAction | null;

export interface IFailedActionAdd {
  type: 'IFailedActionsAdd';
  failedAction: IFailedAction;
}

export interface IFailedActionRemove {
  type: 'IFailedActionsRemove';
}

export function addFailedAction(failedAction: IFailedAction): IFailedActionAdd {
  return {
    failedAction,
    type: 'IFailedActionsAdd',
  };
}

export function removeFailedAction(): IFailedActionRemove {
  return {
    type: 'IFailedActionsRemove',
  };
}

export function recallFailedAction(failedAction: IFailedAction): TThunkAction {
  return dispatch => {
    dispatch(removeFailedAction());

    const { type, ...action } = failedAction;

    if (type === 'ISubscriptionsDeleted') {
      dispatch(deleteSubscriptionItem(action as any));
    }

    if (type === 'IIsActiveUpdated') {
      dispatch(updateIsActive(action as any));
    }

    if (type === 'IFrequencyUpdated') {
      dispatch(updateSubscriptionFrequency(action as any));
    }

    if (type === 'IIsActiveCategoryUpdated') {
      dispatch(updateIsActiveCategory(action as any));
    }

    if (type === 'IMailingToggleUpdated') {
      dispatch(updateMailingToggle(action.payload as any));
    }
  };
}

export type TFailedAction = IFailedActionAdd | IFailedActionRemove;

const initialState = null;

export const failedActionReducer: Reducer<TFailedActionState, TFailedAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'IFailedActionsAdd':
      return action.failedAction;

    case 'IFailedActionsRemove':
      return null;

    default:
      return state;
  }
};
